/** Exportação da audiência em CSV — para abrir no Excel (separador `;`, BOM UTF-8). */
import type { Audience } from './engagement';

const SEP = ';';

function cell(v: unknown): string {
  const s = v === null || v === undefined ? '' : String(v);
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function audienceCsv(a: Audience): string {
  const head = [
    'Nome',
    'E-mail',
    'Cargo',
    'Área',
    'Sessões',
    'Assistido (s)',
    '% da aula',
    'Concluiu',
    'Curtiu',
    'Primeiro acesso',
    'Último acesso',
    'Dispositivo',
    'Navegador',
    'Sistema',
    'IP',
    'Buffering (ms)',
  ];
  const rows = a.people.map((p) => [
    p.full_name,
    p.email,
    p.cargo,
    p.area,
    p.sessions,
    Math.round(p.watched_s),
    p.percent,
    p.completed ? 'sim' : 'não',
    p.liked ? 'sim' : 'não',
    p.first_seen_at,
    p.last_seen_at,
    p.device_type,
    p.browser,
    p.os,
    p.ip,
    p.buffering_ms,
  ]);
  // BOM: sem ele o Excel abre acentos quebrados.
  return '﻿' + [head, ...rows].map((r) => r.map(cell).join(SEP)).join('\r\n');
}

export function csvFileName(lessonTitle: string, date = new Date()): string {
  const slug = lessonTitle
    .normalize('NFKD')
    .replace(/[^\p{ASCII}]/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return `audiencia-${slug || 'aula'}-${date.toISOString().slice(0, 10)}.csv`;
}
